import { DateValid } from '@api'
import { mobilePhoneReg } from '@libs/reg'

export const editForm = async function () {
  const result = [
    {
      key: 'UserName',
      type: 'input',
      label: '姓名',
      rules: [
        {
          pattern:  /^((?!\*).)+$/,
          message: '请输入正确的格式',
          trigger: 'blur'
        }
      ]
    }, {
      key: 'SubscribeType',
      type: 'select',
      label: '预约类型',
      options: [
        { text: '请选择', value: '' },
        { text: '个人', value: 'User' },
        { text: '单位', value: 'Company' }
      ],
      rules: [],
      onChange: (val, item, formItems) => {
        const obj = formItems.find(f => f.key === 'CompanyName')
        this.$set(obj, 'hide', val === 'User')
        this.$set(obj, 'value', '')
      }
    }, {
      key: 'CompanyName',
      type: 'input',
      label: '单位名称',
      hide: true,
      rules: []
    }, {
      key: 'CardStyle',
      type: 'select',
      label: '证件类型',
      options: [
        { text: '请选择', value: '' },
        { text: '身份证', value: '1' },
        { text: '护照', value: '2' },
        { text: '军官证', value: '3' }
      ],
      rules: []
    }, {
      key: 'CardNo',
      type: 'input',
      label: '证件号码',
      rules: [
        {
          pattern:  /^((?!\*).)+$/,
          message: '请输入正确的格式',
          trigger: 'blur'
        }
      ]
    }, {
      key: 'Phone',
      type: 'input',
      label: '移动电话',
      rules: [
        {
          pattern: mobilePhoneReg,
          message: '请输入正确的格式',
          trigger: 'blur'
        }
      ]
    }, {
      key: 'Tel',
      type: 'input',
      label: '固定电话'
    }, 
    {
      key: 'EMail',
      type: 'input',
      label: '邮箱',
      rules: [
        { required: true, message: '请填写邮箱', trigger: 'blur' },
        { type: 'email', message: '请填写正确格式', trigger: 'blur' }
      ]
    }
    ,{
      key: 'WorkUnit',
      type: 'input',
      label: '工作单位',
      rules: []
    }, {
      key: 'QueryContent',
      type: 'input',
      inputType: 'textarea',
      label: '查询内容',
      placeholder: '请详细描述',
      width: '100%',
      autosize: { minRows: 2 },
      rules: []
    }, {
      key: 'QueryPurpose',
      type: 'input',
      inputType: 'textarea',
      label: '查询目的',
      placeholder: '请详细描述',
      width: '100%',
      autosize: { minRows: 2 },
      rules: []
    }, {
      key: 'IsStamp',
      type: 'select',
      label: '是否盖章',
      options: [
        { text: '请选择', value: '' },
        { text: '是', value: '1' },
        { text: '否', value: '0' },
      ],
      rules: []
    }, {
      key: 'ResultStyle',
      type: 'select',
      label: '取档方式',
      options: [
        { text: '请选择', value: '' },
        { text: '自取', value: 'ZQ' },
        { text: '快递到付', value: 'EMS' },
      ],
      rules: [],
      onChange: (val, item, formItems) => {
        const obj1 = formItems.find(f => f.key === 'SubscribeZQDate')
        const obj2 = formItems.find(f => f.key === 'EmsAddress')
        this.$set(obj1, 'hide', val === 'EMS')
        this.$set(obj2, 'hide', val === 'ZQ')
        this.$set(obj1, 'value', '')
        this.$set(obj2, 'value', '')
        this.tipsVisible = val === 'ZQ'
      }
    }, {
      key: 'SubscribeZQDate',
      type: 'date',
      label: '预约日期',
      rules: [],
      onChange: async ({ val, item }) => {
        if (!val) return
        const { data } = await DateValid({ YYDate: val })
        if (data === 'no') {
          item.value = ''
          this.$Message.warning(this.$config.appointmentDateTips);
        }
      }
    }, {
      key: 'EmsAddress',
      type: 'input',
      label: '通讯地址',
      placeholder: '请认真填写您的收件地址',
      width: '100%',
      hide: true,
      rules: []
    }
  ]
  const { item } = this
  result.map(m => {
    const { key, type } = m
    m.width = m.width || '33.3%'
    // 给每项rules添加规则
    if (m.rules) {
      let temp1, temp2
      switch (m.type) {
        case 'select':
          temp1 = '选择'
          temp2 = 'change'
          break
        default:
          temp1 = '输入'
          temp2 = 'blur'
          break
      }
      const obj = {
        required: true,
        message: `必须${temp1}${m.label}`,
        trigger: temp2
      }
      if (m.type === 'date') {
        obj.type = 'date'
      }
      m.rules.unshift(obj)
    }
    // 值处理
    if (!item.SID) {
      // 预设值
      switch (key) {
        case 'SubscribeType': // 预约类型
          m.value = 'User'
          break
        case 'CardStyle': // 证件类型
          m.value = '1'
          break
        case 'IsStamp': // 是否盖章
          m.value = '1'
          break
        case 'ResultStyle': // 取档方式
          m.value = 'ZQ'
          break
      }
    } else if (key === 'SubscribeZQDate') {
      // 预约日期
      m.hide = item['ResultStyle'] === 'EMS'
      if (!item[key]) return
      const temp = item[key].split('')
      temp.splice(4, 0, '-')
      temp.splice(7, 0, '-')
      m.value = item[key] && new Date(temp.join(''))
    } else if (key === 'CompanyName') {
      // 单位名称
      m.hide = item['SubscribeType'] === 'User'
      m.value = item[key]
    } else if (key === 'EmsAddress') {
      // 通讯地址
      m.hide = item['ResultStyle'] === 'ZQ'
      m.value = item[key]
    } else if (type === 'date') {
      m.value = item[key] && new Date(item[key])
    } else if (key === 'Phone') {
      m.value = item[key].replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    } else if (key === 'CardNo') {
      m.value = item[key].replace(/(.{2}).*(.{2})/, '$1****$2')
    } else if (key === 'UserName') {
      const name = item[key]
      m.value = name[0].padEnd(name.length, '*')
    } else {
      m.value = item[key]
    }
    // 阅读模式
    if (this.readonly) {
      m.disabled = this.readonly
      m.rules = []
    }
  })
  return result
}
